import mixin from '../../mixins/Mixin';

export default (editor, config = {}) => {
  const c = config;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const pfx = c.countdownClsPfx;
  var Modele;
  domc.addType('custom-countdown', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'custom-countdown',
          config: btoa(JSON.stringify(config)),
          tagName: 'div',
          selectable: true,
          traits: [
            {
              type: 'select',
              label: 'Model',
              name: 'Modele',
              options: [
                { value: 'CountDown1', name: c.countdown1 },
                { value: 'CountDown2', name: c.countdown2 },
                { value: 'CountDown3', name: c.countdown3 },
              ],
              changeProp: 1,
            },
            {
              type: c.dateInputType,
              label: 'Date cible',
              name: 'startfrom',
              changeProp: 1,
            },
            {
              type: 'time',
              label: 'Temps cible',
              name: 'hourfrom',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'Afficher la date de début',
              name: 'showStartDate',
              valueTrue: 'show',
              valueFalse: 'hide',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Position',
              name: 'position',
              options: [
                { value: 'start', name: c.textBefore },
                { value: 'end', name: c.textAfter },
              ],
              changeProp: 1,
            },

            {
              type: 'select',
              label: 'Choisir le format',
              name: 'source',
              options: [
                { value: 'JJ/MM/AAAA', name: '01/01/2020' },
                { value: 'JJ/MMMM/AAAA', name: '01 january 2020' },
                //{ value: 'JJ/MMMMM/AAAA', name: '01/january/2020' },
                { value: 'JJ/MM', name: '01/01' },
                { value: 'JJ/MMMM', name: '01 january' },
              ],
              changeProp: 1,
            },

            {
              label: 'Texte de début',
              name: 'startText',
              changeProp: 1,
            },

            {
              type: 'select',
              label: c.labelDays,
              name: 'formJours',
              options: [
                { value: c.labelDays, name: c.labelDays },
                { value: 'Jr', name: 'Jr' },
                { value: 'J', name: 'J' },
              ],
              changeProp: 1,
            },
            {
              type: 'select',
              label: c.labelHours,
              name: 'formHeures',
              options: [
                { value: c.labelHours, name: c.labelHours },
                { value: 'Hr', name: 'Hr' },
                { value: 'H', name: 'Hr' },
              ],
              changeProp: 1,
            },
            {
              type: 'select',
              label: c.labelMinutes,
              name: 'formMinutes',
              options: [
                { value: c.labelMinutes, name: c.labelMinutes },
                { value: 'Mn', name: 'Mn' },
                { value: 'M', name: 'M' },
              ],
              changeProp: 1,
            },
            {
              type: 'select',
              label: c.labelSeconds,
              name: 'formSecondes',
              options: [
                { value: c.labelSeconds, name: c.labelSeconds },
                { value: 'Sec', name: 'Sec' },
                { value: 'S', name: 'S' },
              ],
              changeProp: 1,
            },
            {
              label: 'End text',
              name: 'endText',
              changeProp: 1,
            },
          ],
          copyable: true,
          endText: c.endText,
          showStartDate: 'show',
          source: 'JJ/MM/AAAA',
          position: 'start',
          formJours: c.labelDays,
          formHeures: c.labelHours,
          formSecondes: c.labelSeconds,
          formMinutes: c.labelMinutes,
          // resizable: {
          //   step: 0.2,
          //   minDim: 15,
          //   maxDim: 100,
          //   currentUnit: 1,
          //   autoHeight: true,
          //   tl: 1, // Top left
          //   tc: 0, // Top center
          //   tr: 1, // Top right
          //   cl: 0, // Center left
          //   cr: 0, // Center right
          //   bl: 1, // Bottom left
          //   bc: 0, // Bottom center
          //   br: 1, // Bottom right
          // },
          init() {
            this.listenTo(this.model, 'change:Modele', this.updateScript);
            this.listenTo(
              this.model,
              'change:startfrom change:hourfrom change:showStartDate change:endText change:position',
              this.updateScript,
            );
          },
          updateScript() {
            this.script();
          },
          script: function() {
            var startfrom = '{[ startfrom ]}';
            var hourfrom = '{[ hourfrom ]}';
            var showText = '{[ showStartDate ]}';
            var endTxt = '{[ endText ]}';
            var position = '{[ position ]}';

            let countDownDate = new Date(startfrom).getTime();
            let countdownCont = this.querySelector('[data-js=countdown-cont]');
            var countdownEl = this.querySelector('[data-js=countdown]');
            var endTextEl = this.querySelector('[data-js=countdown-endtext]');
            var textEl = this.querySelector('[data-js=countdown-text]');
            var dateEl = this.querySelector('[data-js=countdown-date]');
            var dayEl = this.querySelector('[data-js=countdown-day]');
            var hourEl = this.querySelector('[data-js=countdown-hour]');
            var minuteEl = this.querySelector('[data-js=countdown-minute]');
            var secondEl = this.querySelector('[data-js=countdown-second]');
            var oldInterval = this.gjs_countdown_interval;
            if (endTextEl) {
              endTextEl.style.display = 'none';
            }
            if (oldInterval) {
              oldInterval && clearInterval(oldInterval);
            }
            if (showText) {
              if (textEl) {
                if (showText === 'show') {
                  textEl.style.display = 'flex';
                } else {
                  textEl.style.display = 'none';
                }
              }
              var setCircleAnimation = function(days, hours, minutes, seconds) {
                let xSeconds = 60 / seconds;
                let xMinute = 60 / minutes;
                let xHours = 24 / hours;
                let xDays = 365 / days;
                let initialOffsetxSeconds = 440 - 440 / xSeconds;
                let initialOffsetxMinute = 440 - 440 / xMinute;
                let initialOffsetxHours = 440 - 440 / xHours;
                let initialOffsetxDays = 440 - 440 / xDays;
                if ('00' === seconds) {
                  return;
                }

                $('.circle_animation_second').css('stroke-dashoffset', initialOffsetxSeconds);
                $('.circle_animation_minute').css('stroke-dashoffset', initialOffsetxMinute);
                $('.circle_animation_hour').css('stroke-dashoffset', initialOffsetxHours);
                $('.circle_animation_day').css('stroke-dashoffset', initialOffsetxDays);
              };

              var setTimer = function(days, hours, minutes, seconds) {
                setCircleAnimation(days, hours, minutes, seconds);
                dayEl.innerHTML = days < 10 ? '0' + days : days;
                hourEl.innerHTML = hours < 10 ? '0' + hours : hours;
                minuteEl.innerHTML = minutes < 10 ? '0' + minutes : minutes;
                secondEl.innerHTML = seconds < 10 ? '0' + seconds : seconds;
              };
            }
            var moveTimer = function() {
              var now = new Date().getTime();
              if (hourfrom) {
                countDownDate = new Date(startfrom + 'T' + hourfrom).getTime();
              }
              var distance = countDownDate - now;

              var days = Math.floor(distance / 86400000);
              var hours = Math.floor((distance % 86400000) / 3600000);
              var minutes = Math.floor((distance % 3600000) / 60000);
              var seconds = Math.floor((distance % 60000) / 1000);

              setTimer(days, hours, minutes, seconds);

              /* If the count down is finished, write some text */
              if (distance < 0) {
                clearInterval(interval);
                endTextEl.innerHTML = endTxt;
                countdownEl.style.display = 'none';
                if (countdownCont) {
                  countdownCont.style.padding = '0.8em 10em';
                }
                if (textEl) {
                  textEl.style.display = 'none';
                }
                if (dateEl) {
                  dateEl.style.display = 'none';
                }
                endTextEl.style.display = '';
              }
            };

            if (countDownDate) {
              var interval = setInterval(moveTimer, 1000);
              this.gjs_countdown_interval = interval;
              endTextEl.style.display = 'none';
              if (countdownCont) {
                if (position === 'start') {
                  countdownCont.style.padding = '0.8em 0 0 0em';
                } else {
                  countdownCont.style.padding = '0 0 0.8em 0em';
                }
              }
              countdownEl.style.height = '';

              moveTimer();
            } else {
              setTimer(0, 0, 0, 0);
            }
          },
        }),
        init() {
          this.listenTo(
            this,
            'change:Modele change:formJours change:formHeures change:formSecondes change:formMinutes  ',
            this.updateModele,
          );
          this.listenTo(
            this,
            'change:position change:showStartDate change:startfrom change:hourfrom change:startText change:source',
            this.updatePositionText,
          );
          this.listenTo(
            this.model,
            'change:startfrom change:hourfrom change:endText change:position',
            this.updateScript,
          );

          var configMixin = mixin.methods.getLangCode('display-countdown-plugin');
          window.y = this;
          this.attributes.traits.models.forEach((p, index) => {
            var name = p.attributes.name;
            p.set('label', configMixin.translate[name]);
            p.set('title', configMixin.translate[name]);
          });
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') === 'custom-countdown'
            ? this.view.el.outerHTML
            : '';
        },
        updateModele() {
          this.view.changeModele(this.get('Modele'));
        },
        updatePositionText() {
          this.view.changePositionText(
            this.get('position'),
            this.get('showStartDate'),
            this.get('startfrom'),
            this.get('hourfrom'),
            this.get('startText'),
            this.get('source'),
          );
        },
        isComponent(el) {
          if (el.getAttribute('data-gjs-type') === 'custom-countdown') {
            return {
              type: 'custom-countdown',
            };
          }
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'custom-countdown' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      init() {
        this.listenTo(this, 'change:Modele', this.updateModele);
        this.listenTo(
          this.model,
          'change:startfrom change:hourfrom change:showStartDate change:endText change:position',
          this.updateScript,
        );
      },
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },

      /**
       * Update the map on the canvas
       * @private
       */

      changeType(input, type) {
        var now = new Date(input);
        var year = now.getFullYear();
        var date = now.getDate();
        var months = [
          'january',
          'february',
          'march',
          'april',
          'may',
          'june',
          'july',
          'august',
          'september',
          'october',
          'november',
          'december',
        ];
        var month = months[now.getMonth()];
        //var monthTra = conf.translate[month];
        var JJ_MM_AAAA = date + '/' + Number(months.indexOf(month) + 1) + '/' + year;
        var JJ_MM = date + '/' + Number(months.indexOf(month) + 1);
        var JJMMMMAAAA = date + ' ' + months[now.getMonth()] + ' ' + year;
        var JJMMMM = date + ' ' + months[now.getMonth()];
        if (type === 'JJ/MM/AAAA') return JJ_MM_AAAA;
        if (type === 'JJ/MMMM/AAAA') return JJMMMMAAAA;
        if (type === 'JJ/MM') return JJ_MM;
        if (type === 'JJ/MMMM') return JJMMMM;
        if (type === ' ' || !type) return ' ';
      },
      changePositionText(position, showText, startfrom, hourfrom, startText, type) {
        if (position) {
          localStorage.setItem('position', position);
        }
        if (startfrom) {
          let newVal = this.changeType(startfrom, type);
          localStorage.setItem('startfrom', newVal);
          if (new Date(startfrom).getTime() > new Date().getTime()) {
            this.model.set('showstartdate', 'show');
          }
        }

        if (showText) {
          localStorage.setItem('showText', showText);
          this.model.set('showstartdate', showText);
          this.displayDateTraits(showText);
        }
        if (startText) {
          // localStorage.setItem('startText', startText);
        }
        localStorage.setItem('gjs-js', editor.getJs());
        this.handleUpdate();
        const comps = this.model.get('components');
        if (comps.length !== 0) {
          this.getComponent();
        }
      },
      displayDateTraits(showText) {
        window.z = this.model;
        let traits = ['position', 'startText', 'source'];
        if (
          this.model.get('traits') &&
          this.model.get('traits').models &&
          this.model.get('traits').length > 0
        ) {
          for (let i = 0; i < this.model.get('traits').models.length; i++) {
            if (traits.indexOf(this.model.get('traits').models[i].attributes.name) > -1) {
              this.model.get('traits').models[i].set('showStartDate', showText);
              if (this.model.get('traits').models[i].view.el) {
                if (showText === 'show') {
                  this.model.get('traits').models[i].view.el.style.display = 'flex';
                } else {
                  this.model.get('traits').models[i].view.el.style.display = 'none';
                }
              }
            }
          }
        }
      },
      changeModele(Modeles, self) {
        if (Modeles) {
          Modele = Modeles;
          localStorage.setItem('Modele', Modele);
        }
        this.model.set('Modele', Modele);
        let classes = this.model.getClasses();
        let cssComposer = editor.CssComposer;
        let style = {};
        localStorage.setItem('gjs-js', editor.getJs());
        this.handleUpdate();
        const comps = this.model.get('components');
        if (comps.length !== 0) {
          this.getComponent();
        }
        //--------------------------------------
        if (classes && classes[0]) {
          let oldStyle =
            cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
              ? cssComposer.getClassRule(classes[0]).attributes.style
              : {};
          style = {
            'border-radius': '0px;',
          };
          if (Modeles === 'CountDown2') {
            style = {
              'border-radius': '10.6px;',
            };
          }
          let newStyle = Object.assign({}, oldStyle, style);
          cssComposer.setClassRule(classes[0], newStyle);
        }
      },
      handleUpdate() {

        let tidesModel = editor
          .getComponents()
          .models.find(item => this.view && item.attributes.attributes.id === this.view.el.id);
        let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(
          item => {
            if (this.view && item.attributes.id === this.view.el.id) {
              item = tidesModel;
            }
            return item;
          },
        );
        this.updateScript();
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
      },
      getComponent() {
        this.model.set(
          'config',
          btoa(JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin'))),
        );
        let styleModel = localStorage.getItem('Modele') || this.model.get('Modele') || 'CountDown1';
        let startEnd = localStorage.getItem('position') || this.model.get('position') || 'start';
        let startfrom = localStorage.getItem('startfrom') || this.model.get('startfrom') || ' ';
        let startText = localStorage.getItem('startText') || this.model.get('startText') || ' ';
        //  let showText = localStorage.getItem('startText') || this.model.get('startText') || ' ';
        let endText = localStorage.getItem('endText') || this.model.get('endText') || ' ';

        let formJours = this.model.get('formJours');
        let formHeures = this.model.get('formHeures');
        let formSecondes = this.model.get('formSecondes');
        let formMinutes = this.model.get('formMinutes');

        const comps = this.model.get('components');
        const content = `  
           <div class="countdown-container">
          <span data-js="countdown-cont" class=" ${pfx}-cont ${styleModel}">
        
           <div data-js="countdown-text" class="${pfx}-text-${startEnd}  showText" >    ${startText +
          ' '}  
             <span data-js="countdown-date" class="countdown-date">  ${startfrom}  </span>     
            </div>
           <span data-js="countdown"    class="${pfx}-cont">
              <div class="${pfx}-block">
               <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ${styleModel}">
                 <g>
                  <circle id="circle" class="circle_animation_day" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>
                 </g>
                </svg>
                <div data-js="countdown-day" class="${pfx}-digit"></div>
                <div class="${pfx}-label">${formJours}</div>
              </div>
             <div class="point"> :</div>
              <div class="${pfx}-block">
               <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ${styleModel}">
                 <g>
                  <circle id="circle" class="circle_animation_hour" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>
                 </g>
                </svg>
                <div data-js="countdown-hour" class="${pfx}-digit"></div>
                <div class="${pfx}-label">${formHeures}</div>
              </div>
              <div class="point"> :</div>
              <div class="${pfx}-block">
               <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ${styleModel}">
                 <g>
                  <circle id="circle" class="circle_animation_minute" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>
                 </g>
                </svg>
                <div data-js="countdown-minute" class="${pfx}-digit"></div>
                <div class="${pfx}-label">${formMinutes}</div>
              </div>
              <div class="point"> :</div>
              <div class="${pfx}-block">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ${styleModel}">
                 <g>
                  <circle id="circle" class="circle_animation_second" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>
                 </g>
                </svg>
                <div data-js="countdown-second" class="${pfx}-digit"></div>
                <div class="${pfx}-label">${formSecondes}</div>
              </div>
            </span>
            <span data-js="countdown-endtext" class="${pfx}-endtext">${endText}</span>

           </span>  
</div>
          

`;
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      render(...args) {
        let config = btoa(JSON.stringify(mixin.methods.getLangCode('display-countdown-plugin')));
        this.model.set('config', config);
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          Modele = this.model.get('Modele') || 'CountDown1';
          localStorage.setItem('position', 'start');
          localStorage.setItem('startfrom', '');
          this.model.set('showStartDate', 'show');
          this.changeModele(Modele);
          this.getComponent();
        }
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/countDown/components.js